// extracted by mini-css-extract-plugin
export default {"content":"content__fJhCq","logo":"logo__5v5sv","section":"section__d7fRm"};